/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

/* eslint-disable max-len */

import { FC, useState, useRef } from 'react';

import { ReadEmailAction } from '@/commons/data';
import { cn } from '@/utils';

export const LastReadEmail: FC<{
    readEmailAction: ReadEmailAction;
}> = function ({ readEmailAction }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const handleMouseEnter = () => {
        timerRef.current = setTimeout(() => {
            setIsExpanded(true);
        }, 1500);
    };

    const handleMouseLeave = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        setIsExpanded(false);
    };

    const hasReadEmails = readEmailAction.email ? [readEmailAction.email] : readEmailAction.otherEmails || [];
    const mostRecentEmail = [...hasReadEmails].sort(
        (a, b) => new Date(b.date_received).getTime() - new Date(a.date_received).getTime(),
    )[0];

    return (
        mostRecentEmail && (
            <button
                className={cn('text-left', isExpanded ? 'whitespace-normal' : 'truncate')}
                title={'Click to copy the HTML contents into clipboard'}
                onClick={() => navigator.clipboard.writeText(mostRecentEmail.content)}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                Last email read from {mostRecentEmail.from} ({mostRecentEmail.date_received}): {mostRecentEmail.subject}{' '}
                - {mostRecentEmail.snippet}
            </button>
        )
    );
};
